import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import ProductItem from '../Category/ProductItem';
import Filter from '../../hocs/Filter/Filter';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import Top from '../Top/Top';
import { retrieveProductCache } from '../../actions/checkout';
import { translate } from '../../utils/locale';

import { unique, intersect } from '../../utils/array';
import s from './SearchResults.scss';

class SearchResults extends Component {
	render() {
		const { setup, searchInputText = '', productCache, filter, closeSearch } = this.props;
		const filtering = productCache?.[setup.market]?.[setup.pricelist];
		if (!filtering) {
			this.props.retrieveProductCache();
			return null;
		}

		const searchTerms = filtering.searchTerms.en;
		let productList = [];

		if (searchInputText !== '' && searchInputText.length > 2) {
			searchInputText.split(' ').forEach((wordPart, i) => {
				if (wordPart === '') return;
				let currentSearchMatch = [];

				Object.keys(searchTerms).forEach((term) => {
					const wordPartIndex = term.toLowerCase().indexOf(wordPart.toLowerCase());
					let specificity = 1;

					if (wordPartIndex !== -1) {
						specificity = 1 / searchTerms[term].length; // More products per key = less specific
						specificity = specificity * 100 * (wordPartIndex === 0 ? 10 : 1);

						currentSearchMatch.push({ term, specificity, products: searchTerms[term] });
					}
				});


				if (currentSearchMatch.length === 0 && i === 0) return;

				currentSearchMatch.sort((a, b) => a.specificity - b.specificity);
				currentSearchMatch = currentSearchMatch.reduce((acc, product) => [...acc, ...product.products], []);
				currentSearchMatch = unique(currentSearchMatch);

				productList = i === 0 ? [...currentSearchMatch] : intersect(productList, currentSearchMatch);
			});
		}

		productList = productList.sort((a, b) => {
			if (!filtering.products[a] || !filtering.products[b]) return -1;
			return filtering.products[a].added < filtering.products[b].added ? 1 : -1;
		});

		return (
			<div className={s.searchResults}>
				<Top setup={setup} pageContent={{ metaRobots: 'noindex' }} paths={Object.keys(setup.languages).reduce((acc, l) => ({ ...acc, [l]: 'search' }), {})} locationType="SEARCH" />
				{
					searchInputText.length > 2 && (
						<div className={s.searchResults_top}>
							<div className={s.searchResults_top_term}><strong>{ productList.length }</strong> <span>{ translate(setup, 'searchTerm') }</span><span>{ ` “${searchInputText}”` }</span></div>
							<div className={s.searchResults_top_amount}><span>{ `${translate(setup, 'searchShowing')} ` }</span><span>{ translate(setup, 'searchResults').replace('%amount%', productList.length) }</span></div>
						</div>
					)
				}
				{
					searchInputText.length > 2 && (
						<ErrorBoundary message="Search Filter:" debugData={filtering}>
							<Filter ListComponent={ProductItem} list={productList} filter={filter} filtering={filtering} setup={setup} currentPath="search" canonical closeSearch={closeSearch} />
						</ErrorBoundary>
					)
				}
			</div>
		);
	}
}

const mapState = ({ environment, productCache, filtering, filter, location }, props) => ({
	setup: environment.setup,
	searchInputText: environment.searchInputText,
	productCache,
	filtering,
	location,
	filter,
	...props,
});

export default hot(module)(connect(mapState, { retrieveProductCache })(SearchResults));
